import axios from 'axios'
import Vue from 'vue'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import { localRead, getQueryString } from '@/utils/tools'
import router from '../router/index'
// create an axios instance
const service = axios.create({
    timeout: 60000 // request timeout
})
const toLogin = () => {
        router.replace({
            path: '/login'
        })
    }
    // request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent
        let language = 'zh_CN';
        if (localRead('language')) {
            language = (localRead("language"))
        }
        // //根据请求方法的不同 统一添加上language字段
        if (config.method == "get") {
            if (config.params) config.params['language'] = language;
            else config.params = { language: language }
        } else if (config.method == "post") {
            if (config.headers['Content-Type'] == "application/json") {
                config.url = config.url + "?language=" + language
            }else if (config.headers['Content-Type'] == "multipart/form-data") {
                config.url = config.url + "?language=" + language
            } else {
                config.data = config.data + "&language=" + language
            }

        }

        // 配置 config.headers['Authorization']
        if (localRead('sysToken')) {
            config.headers['Authorization'] = localRead('sysToken')
        } else
        if (window.SITE_CONFIG['routerLabel']) {
            config.headers['Authorization'] = getToken(window.SITE_CONFIG['routerLabel'])
        } else if (window.location.href.indexOf('label') != -1) {

            let labelRouter = getQueryString('label')
            config.headers['Authorization'] = getToken(labelRouter)
        }

        //36/98项目添加业务组字段
        const href = window.location.href;
        let routerLabel;
        if(localRead('sysCode')){
            routerLabel=JSON.parse(localRead('sysCode'))[0].code;
        }
        if (window.SITE_CONFIG['routerLabel']) {
            routerLabel=window.SITE_CONFIG['routerLabel'];
        }else if (window.location.href.indexOf('label') != -1) {
            routerLabel = getQueryString('label');
        }
        if(routerLabel){
            if(localRead(routerLabel + "_sys_userInfo")){
                config.headers['companyCode'] = JSON.parse(localRead(routerLabel + "_sys_userInfo")).companyCode;
                console.log("companyCode:"+JSON.parse(localRead(routerLabel + "_sys_userInfo")).companyCode)
            }
        }


        return config;
    },
    error => {
        console.log(error)
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(

    response => {
        const res = response.data
        if (res.code !== 0) {
            if(res.type == 'application/vnd.ms-excel' || res.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
                return res
            }
            if(res.msg){
                return res
            }
            Message({
                message: res.message || 'Error',
                type: 'error',
                duration: 5 * 1000
            })
            if (res.code === 401) {

                MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
                    confirmButtonText: 'Re-Login',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    store.dispatch('user/resetToken').then(() => {
                        toLogin()
                    })
                })
            }
            return Promise.reject(new Error(res.message || 'Error'))
        } else {
            return res
        }
    },
    error => {
        console.log('err' + error) // for debug
        if (error.response != undefined) {
            Message({
                message: error.response.data.message,
                type: 'error',
                duration: 5 * 1000
            })
            if (error.response.data.code == 401) {
                store.dispatch('user/resetToken').then(() => {
                    toLogin()
                })
            }
        } else {
            Message({
                message: error,
                type: 'error',
                duration: 5 * 1000
            })
        }

        return Promise.reject(error)
    }
)


/*将axios添加到vue中，可以直接使用*/
Plugin.install = function(Vue, options) {
    Vue.axios = service;
    window.axios = service;
    Object.defineProperties(Vue.prototype, {
        axios: {
            get() {
                return service;
            }
        },
        $axios: {
            get() {
                return service;
            }
        },
    });
};

Vue.use(Plugin)

export default service
